const container = {
  position: "relative",
  marginTop: 16,
};

const accordionItem = {
  justifyContent: "space-between",
  border: "1px solid",
  borderColor: "primary.20",
  borderRadius: "small",
  padding: 12,
  cursor: "pointer",
  "&:hover": {
    backgroundColor: "primary.20",
  },
};

const content = {
  display: "flex",
  flexDirection: "column",
};

const description = {
  overflow: "hidden",
};

const iconContainer = {
  margin: "0 9px 0 4px",
  flexShrink: 0,
  alignSelf: "flex-start",
};

const title = {
  marginRight: "auto",
};

const uiAction = {
  margin: "8px 5.53px 0 17.53px",
  flexShrink: 0,
  alignSelf: "flex-start",
};

const uiActionIcon = {
  width: 16,
  height: 16,
};

const promotionalPill = {
  position: "absolute",
  right: 16,
  top: -11,
};

export default {
  container,
  content,
  title,
  description,
  iconContainer,
  uiAction,
  uiActionIcon,
  promotionalPill,
  accordionItem,
};
